import React from 'react'
import '../Styles/Nav.css'
// import { useNavigate } from 'react-router-dom';

export default function Nav() {
  // const navigate = useNavigate();
  const querynavigatehandler = (e)=>{
    // navigate('./contact');
    window.location.href = `/contact`;
  }
  const navlogoclicked = ()=>{
    window.location.href = '/';
  }
  const sec1menucloseclickhandler = ()=>{
    const sec1menu = document.querySelector('.sec1menu');
    sec1menu.style.display = 'none';
  }
  // -----------------------------------------------
  const sec1menuopenclickhandler = ()=>{
    const sec1menu = document.querySelector('.sec1menu');
    sec1menu.style.display = 'block';
  }

  return ( 
    <div className='nav'>
      <div className="sec1menu">
        <i className="sec1menuclose fa-solid fa-close" onClick={sec1menucloseclickhandler}></i>
        <div className="sec1menubox1">
          <div className="sec1menuleft">
            <a href="/courses">Programs</a>
            <a href="/admission">Admissions</a>
            <a href="/gallery">Campus of MD</a>
            <a href="/gallery">Life @ MD</a>
            <a href="/about">About</a>
          </div>
          <div className="sec1menuright">
            <a href="/thoughts">Chairman Thoughts</a>
            <a href="/">Home</a>
            <a href="/courses">Courses</a>
            <a href="/gallery">Gallery</a>
            <a href="/vision">Visionary Management</a>
            <a href="/vision">Institute Vision and Mission</a>
            <a href="/gallery">Why MD ?</a>
            <a href="/testimonial">Testimonials</a>
            <a href="/contact">Contact US</a>
          </div>
        </div>
        <div className="sec1menubox2">
          <div className="sec1menupara">YOU HAVE QUESTIONS. WE HAVE ANSWERS</div>
          <div className="sec1menubtn" onClick={querynavigatehandler}>ASK YOUR QUERY</div>
        </div>
      </div>
        <div className="navcontainer">
            <div className="navleft">
                <img className='navlogo' src="./images/navlogofinal.png" alt="logo" onClick={navlogoclicked} />
            </div>
            <div className="navright">
                <a href="/" className='navhome'>Home</a>
                <a href="/facilities" className='navadmission'>Facilities</a>
                <a href="/about" className='navabout'>About</a>
                <a href="/contact" className='navcontactus'>Contact Us</a>
                <i className="fa-solid fa-bars" onClick={sec1menuopenclickhandler}></i>
            </div>
        </div>
    </div>
  )
}
